import React from 'react'

function CardList(props) {
    
  let latestEndDateTime = new Date(props.vehicleInfo.latestEndDateTime);
  let toDate = `${latestEndDateTime.getUTCDate()}/${latestEndDateTime.getUTCMonth()+1}/${latestEndDateTime.getFullYear()}`
  let earliestStartDateTime = new Date(props.vehicleInfo.earliestStartDateTime);
  let fromDate = `${earliestStartDateTime.getUTCDate()}/${earliestStartDateTime.getUTCMonth()+1}/${earliestStartDateTime.getFullYear()}`
  let rate= `$${props.vehicleInfo.detail.price_per_day}/day`  
  let response = [];
  if (props.vehicleInfo.detail.fuel_allowance) {
    response.push(`Fuel allowance $${props.vehicleInfo.detail.fuel_allowance}`);
  }
  if (props.vehicleInfo.detail.general_allowance) {
    response.push(`General allowance $${props.vehicleInfo.detail.general_allowance}`);
  }
  if (props.vehicleInfo.detail.refund) {
    response.push(`Refund of ${props.vehicleInfo.detail.refund} after dropoff`);
  }
  if (props.vehicleInfo.ship_pax && props.vehicleInfo.ship_pax > 0) {
    response.push(`Includes prebooked ship`);
  }

  if (props.vehicleInfo.free_fuel === 1) {
    response.push(`Free fuel`);
  }
  
  if (response.length > 1) {
     response.join(', ');
  }
  if (response.length) {
    response=response[0];
  }
    
  return (
        <>
     <div className="">
      <div className="vehicle-name"> {props.vehicleInfo.product.name} </div>
      <div className="vehicle-info">
      <div> <span className='vehicle-label'>FROM: </span>{props.vehicleInfo.fromDepots.map(fromDepot => fromDepot.name).join(', ')}</div>
      </div>
      <div className="vehicle-info"><div><span className='vehicle-label'> To: </span>   {props.vehicleInfo.toDepots.map(toDepot => toDepot.name).join(', ')}</div>
      </div>
      <div className="vehicle-info"><div> <span className='vehicle-label'>PICK UP FROM:</span> {fromDate}</div>
      </div>
      <div className="vehicle-info"><div><span className='vehicle-label'> DROP OFF BY: </span> {toDate}</div>
      </div>
      <div className="vehicle-info"><div><span className='vehicle-label'> RATE FROM: </span> {rate}</div>
      </div>
      <div className="vehicle-info"><div><span className='vehicle-label'> INCLUSIONS: </span> {response}</div>
      </div>
      <div className="vehicle-link">
      <a href={props.vehicleInfo.continuationUrl} >Book Offer</a>
      </div>
  </div>
        </>
      )
    }
    export default CardList
